import React from 'react';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import FolderWithPaperMoney from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/FolderWithPaperMoney';
import PaperWithDollarSignAndBarChart from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperWithDollarSignAndBarChart';
import PottedPlantWithDollarSignCircle from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PottedPlantWithDollarSignCircle';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';
// styles
import { ColStyled } from './styles';

export const ITEMS = [
  {
    id: 'universal-life-insurance-flexible-death-benefit',
    icon: PaperWithDollarSignAndBarChart,
    title: 'Flexible death benefit',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        You can start off with a specific amount to meet your current needs, but if things shift down the road, you have the option to increase or even change the type of death benefit &#40;within limits&#41; to fit your situation.
      </Typography>
    ),
  },
  {
    id: 'universal-life-insurance-flexible-premiums',
    icon: FolderWithPaperMoney,
    title: 'Flexible premiums',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        You get to choose how much you pay, and when, which can be helpful if your cashflow fluctuates. Keep in mind, premiums will increase with age &#40;based on the difference between the death benefit and cash value&#41; and as long as there&#39;s enough cash value to pay your policy&#39;s monthly fees, your coverage will continue.<sup>1</sup>
      </Typography>
    ),
  },
  {
    id: 'universal-life-insurance-cash-value',
    icon: PottedPlantWithDollarSignCircle,
    title: 'Cash value',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Use it for anything, anytime, usually without owing taxes. You can help pay for an emergency, home repair, college tuition, even invest in your business, whatever you need.<sup>2</sup> However, your policy could lapse if the net accumulated value of the policy is less than the monthly fees.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='universal-life-insurance'
      backgroundVariant='lightB'
      headingText={<>The benefits of universal <WidowBlock>life policies</WidowBlock></>}
      cardDataArray={ITEMS}
      secondaryContent={
        <Row align='center'>
          <ColStyled align='center'>
            <Link
              id='universal-life-insurance-understanding-product-cta'
              variant='buttonLinkSecondary'
              themeType='lightTheme'
              linkUrl='/life-and-money/what-is-universal-life-insurance/'
              ariaLabel='Find out more about universal life insurance'>
              Find out more
            </Link>
          </ColStyled>
        </Row>
      }
    />
  );
};
